import { styled } from '@mui/system';
import { Typography, Box, Grid2 } from '@mui/material';

export const TypographyStyledHeader = styled(Typography)({
  color: '#002A3A',
  fontSize: '1.625rem',
  fontWeight: 450,
  fontFamily: 'BGBold'
});

export const BoxColStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.875rem',
  width: '50%'
});

export const GridColStyled = styled(Grid2)({
  display: 'flex',
  flexDirection: 'column'
});

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '1.875rem',
  paddingTop: '1.5rem'
});

export const TypographyListStyled = styled(Typography)({
  color: '#002A3A',
  '@media(max-width:767px)': {
    fontSize: '1.05rem'
  }
});
